// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';

// Simple shimmer utility class via inline style
const shimmerStyle: React.CSSProperties = {
  backgroundImage: 'linear-gradient(90deg, rgba(229,231,235,0) 0%, rgba(229,231,235,0.7) 50%, rgba(229,231,235,0) 100%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s ease-in-out infinite',
};

const Shimmer: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className = '', style }) => (
  <div className={`relative overflow-hidden ${className}`} style={style}>
    <div className="absolute inset-0 bg-gray-200" />
    <div className="absolute inset-0" style={shimmerStyle} />
  </div>
);

export const VideoCardSkeleton: React.FC<{ index?: number }> = ({ index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.4, ease: 'easeOut', delay: index * 0.04 }}
    className="bg-white rounded-3xl shadow-xl overflow-hidden"
  >
    <div className="relative h-32 md:h-40">
      <Shimmer className="w-full h-full" />
      <div className="absolute top-4 left-4 w-24 h-6 rounded-full bg-white/60" />
    </div>
    <div className="p-6 space-y-3">
      <div className="h-5 w-3/4 rounded bg-gray-200" />
      <div className="h-4 w-1/3 rounded bg-gray-200" />
      <div className="h-14 rounded-xl bg-gray-100" />
    </div>
  </motion.div>
);

export const MapResultSkeleton: React.FC = () => (
  <div className="flex items-start gap-3 py-3">
    <div className="w-12 h-12 rounded-md bg-gray-200" />
    <div className="flex-1 space-y-2">
      <div className="h-4 w-2/3 bg-gray-200 rounded" />
      <div className="h-3 w-1/2 bg-gray-200 rounded" />
      <div className="h-3 w-1/3 bg-gray-200 rounded" />
    </div>
  </div>
);

// keyframes injected once
if (typeof document !== 'undefined' && !document.getElementById('shimmer-keyframes')) {
  const style = document.createElement('style');
  style.id = 'shimmer-keyframes';
  style.innerHTML = `@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`;
  document.head.appendChild(style);
}
